import React from 'react';
import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SEARCH_DISPENSES_PENDING,
  SEARCH_TOTAL_COUNT,
  ERX_IMAGES_ARRAY,
  ERX_DISPENSED_IMAGES_ARRAY,
  SAVE_DISPENSES_MSG,
  SEARCH_LIST_RESP,
  SEARCH_DISPENSED_LIST,
  SEARCH_DISPENSE_LIST_RESP,
  DOCTOR_REPORT,
  REPORT_COUNT,
  EXCEL_REPORT_LIST,
  SEARCH_DISEASE_DATA,
  SEARCH_DIAGONSIS_DATA,
  SEARCH_SPECIALIZATION_DATA,
  SEARCH_SYMPTOMS_DATA,
  TAG_CATEGORY_REPORT,
  SEARCH_MEDICINE_DATA,
  ALLERGY_REPORT,
  PROCEDURE_REPORT,
  REPORT_RESULT,
  REPORT_RESULT_SUCCESS,
  CLIENT_LIST_REPORT,
} from '../../shared/constants/ActionTypes';
import IntlMessages from '../../@crema/utility/IntlMessages';
import jwtAxios from '../../@crema/services/auth/jwt-auth/jwt-api';
import {fetchError, onWriteCloudWatchLog} from './Common';
//AWS cloud watch name
var streamname = 'Redux_Actions';
var filename = 'eRxReport.js';
export const eRxReportAutocompleteList = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/eRxReportAutocompleteListjwt', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/eRxReportAutocompleteList', value)
              .then((data) => {
                if (data.data.status === 200) {
                  dispatch({type: FETCH_SUCCESS});
                  let tag = data.data.body.tag;
                  let array = [];
                  array.push(data.data.body.list ? data.data.body.list : []);
                  if (tag == 'diagonsis') {
                    dispatch({
                      type: SEARCH_DIAGONSIS_DATA,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'disease') {
                    dispatch({
                      type: SEARCH_DISEASE_DATA,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'investigation') {
                    dispatch({
                      type: TAG_CATEGORY_REPORT,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'specialization') {
                    dispatch({
                      type: SEARCH_SPECIALIZATION_DATA,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'symptoms') {
                    dispatch({
                      type: SEARCH_SYMPTOMS_DATA,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'medicines') {
                    dispatch({
                      type: SEARCH_MEDICINE_DATA,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'doctor') {
                    dispatch({
                      type: DOCTOR_REPORT,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'allergy') {
                    dispatch({
                      type: ALLERGY_REPORT,
                      payload: data.data.body.list,
                    });
                  } else if (tag == 'procedure') {
                    dispatch({
                      type: PROCEDURE_REPORT,
                      payload: data.data.body.list,
                    });
                  }
                } else {
                  dispatch({
                    type: SEARCH_DISEASE_DATA,
                    payload: [],
                  });
                  dispatch({
                    type: FETCH_ERROR,
                    payload: <IntlMessages id='message.somethingWentWrong' />,
                  });
                }
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'onGeSearchDiseaseData',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'onGeSearchDiseaseData',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'onGeSearchDiseaseData',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(
          streamname,
          filename,
          'onGeSearchDiseaseData',
          '0',
          err,
        ),
      );
    }
  };
};
export const eRxReportMasterList = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/eRxReportMasterListjwt', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/eRxReportMasterList', value)
              .then((data) => {
                if (data.status === 200) {
                  dispatch({type: FETCH_SUCCESS});
                  dispatch({
                    type: CLIENT_LIST_REPORT,
                    payload: data.data.body.clientlist,
                  });
                }
              })
              .catch((error) => {
                dispatch({type: FETCH_ERROR, payload: error.message});
                dispatch(
                  onWriteCloudWatchLog(
                    streamname,
                    filename,
                    'ongetclientlist',
                    '0',
                    error,
                  ),
                );
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'ongetclientlist',
                '0',
                err,
              ),
            );
          }
        })
        .catch((error) => {
          dispatch({type: FETCH_ERROR, payload: error.message});
          dispatch(
            onWriteCloudWatchLog(
              streamname,
              filename,
              'ongetclientlist',
              '0',
              error,
            ),
          );
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'ongetclientlist', '0', err),
      );
    }
  };
};
export const onGetExportReportList = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/onGetclientReportListjwt', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/onGetclientReportList', value)
              .then((data) => {
                try {
                  if (data.data.status === 200) {
                    dispatch({type: FETCH_SUCCESS});
                    dispatch({
                      type: EXCEL_REPORT_LIST,
                      payload: data.data.body.result,
                    });
                  }
                } catch (err) {
                  dispatch(fetchError(err.response.message));
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'onGetExportReportList',
                      '0',
                      err,
                    ),
                  );
                }
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'onGetExportReportList',
                '0',
                err,
              ),
            );
          }
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'ongetreportlist', '0', err),
      );
    }
  };
};

export const ongetreportlist = (value) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    try {
      jwtAxios
        .post('v1/reportDtls/onGetclientReportListjwt', value)
        .then((data) => {
          try {
            value['jwtToken'] = data.data.body['token'];
            jwtAxios
              .post('v1/reportDtls/onGetclientReportList', value)
              .then((data) => {
                try {
                  dispatch({type: FETCH_SUCCESS});
                  if (data?.data?.status === 200) {
                    if (data?.data?.body?.result) {
                      dispatch({
                        type: REPORT_RESULT,
                        payload: data.data.body.result,
                      });
                      dispatch({
                        type: REPORT_RESULT_SUCCESS,
                        payload: 'Success',
                      });
                      dispatch({
                        type: REPORT_COUNT,
                        payload: data.data.body.totalcount.totalcount,
                      });
                    } else {
                      dispatch({
                        type: FETCH_ERROR,
                        payload: 'Something went wrong',
                      });
                    }
                  } else {
                    dispatch({
                      type: FETCH_ERROR,
                      payload: 'Something went wrong',
                    });
                  }
                } catch (err) {
                  dispatch(fetchError(err.response.message));
                  dispatch(
                    onWriteCloudWatchLog(
                      streamname,
                      filename,
                      'ongetreportlist',
                      '0',
                      err,
                    ),
                  );
                }
              });
          } catch (err) {
            dispatch(fetchError(err.response.message));
            dispatch(
              onWriteCloudWatchLog(
                streamname,
                filename,
                'ongetreportlist',
                '0',
                err,
              ),
            );
          }
        });
    } catch (err) {
      dispatch(fetchError(err.response.message));
      dispatch(
        onWriteCloudWatchLog(streamname, filename, 'ongetreportlist', '0', err),
      );
    }
  };
};
